import React from 'react';
import { cn } from '../../lib/utils';

function barColor(pct, unlimited) {
  if (unlimited) return 'bg-primary';
  if (pct >= 90) return 'bg-[hsl(var(--destructive))]';
  if (pct >= 70) return 'bg-[hsl(var(--warning))]';
  return 'bg-primary';
}

export function UsageMeter({ label, used = 0, limit = null, valueLabel, testId }) {
  const unlimited = limit === null || limit === undefined;
  const pct = unlimited ? 100 : Math.min(100, Math.round((used / Math.max(1, limit)) * 100));
  const value = valueLabel || (unlimited ? 'Unlimited' : `${used} / ${limit}`);
  return (
    <div className="space-y-1.5" data-testid={testId}>
      <div className="flex items-center justify-between">
        <span className="text-sm">{label}</span>
        <span className="font-mono-edge text-xs text-muted-foreground" data-testid={testId ? `${testId}-value` : undefined}>{value}</span>
      </div>
      <div className="h-2 rounded-full bg-muted overflow-hidden">
        <div
          className={cn('h-full rounded-full transition-[width] duration-200 ease-out', barColor(pct, unlimited))}
          style={{ width: `${unlimited ? 100 : pct}%` }}
        />
      </div>
    </div>
  );
}

export default UsageMeter;
